import { Injectable } from '@angular/core'
import { Address, CommandService, EventService, UserIdService } from '@spartacus/core'
import { MbCheckoutDeliveryFacade } from '../facades/mb-checkout-delivery.facade'
import { catchError, map, switchMap, take, tap } from 'rxjs/operators'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { combineLatest, EMPTY } from 'rxjs'
import { CheckoutDeliveryAddressConnector } from '@spartacus/checkout/base/core'
import { CheckoutDeliveryAddressSetEvent } from '@spartacus/checkout/base/root'
import { CheckoutDeliveryAddressSetFailEvent } from '../../analytics/events/mb-checkout.events'

@Injectable({
  providedIn: 'root'
})
export class MbCheckoutDeliveryService implements MbCheckoutDeliveryFacade {

  constructor (protected activeCartService: ActiveCartFacade,
               protected userIdService: UserIdService,
               protected eventService: EventService,
               protected commandService: CommandService,
               protected checkoutDeliveryConnector: CheckoutDeliveryAddressConnector) { }

  /**
   * Create and set a delivery address without delivery mode using the address param
   *
   * @param address : Address to be created and set
   */
  createAndSetAddressWithoutDeliveryMode (address: Address) {
    this.commandService.create(() =>
      combineLatest([this.userIdService.takeUserId(), this.activeCartService.takeActiveCartId()]).pipe(
        take(1),
        switchMap(([userId, cartId]) =>
          this.checkoutDeliveryConnector.createAddress(userId, cartId, address).pipe(
            map(occAddress => {
              occAddress['titleCode'] = address?.titleCode
              if (address?.region?.isocodeShort) {
                occAddress.region = {
                  ...occAddress?.region,
                  isocodeShort: address?.region?.isocodeShort,
                }
              }
              this.eventService.dispatch(
                {
                  userId,
                  cartId,
                  address,
                }, CheckoutDeliveryAddressSetEvent)
            }),
            catchError(error => {
              this.eventService.dispatch({ error: error }, CheckoutDeliveryAddressSetFailEvent)
              return EMPTY
            })
          )
        )
      )
    ).execute(undefined)
  }

  /**
   * Set delivery address without delivery mode
   *
   * @param address : Address to be set
   */
  setDeliveryAddressWithoutDeliveryMode (address: Address) {
    this.commandService.create(() =>
      combineLatest([this.userIdService.takeUserId(), this.activeCartService.takeActiveCartId()]).pipe(
        take(1),
        switchMap(([userId, cartId]) => {
          const addressId = address.id
          if (!addressId) {
            throw new Error('Checkout conditions not met')
          }
          return this.checkoutDeliveryConnector.setAddress(userId, cartId, addressId).pipe(
            tap(() => this.eventService.dispatch({ userId: userId, cartId: cartId, address: address },
                CheckoutDeliveryAddressSetEvent)
            ),
            catchError(error => {
              this.eventService.dispatch({ error: error }, CheckoutDeliveryAddressSetFailEvent)
              return EMPTY
            })
          )}
        )
      )
    ).execute(undefined)
  }
}
